import { render } from "./ElectionVoteElecomOfficerView.vue?vue&type=template&id=4ab95d90"
import script from "./ElectionVoteElecomOfficerView.vue?vue&type=script&lang=js"
export * from "./ElectionVoteElecomOfficerView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__